var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/heart",
    clipPath: "url(#clip0_1763_6146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.96319 16.9308C9.69477 17.0255 9.25266 17.0255 8.98424 16.9308C6.69477 16.1492 1.57898 12.8887 1.57898 7.36238C1.57898 4.9229 3.54477 2.94922 5.96845 2.94922C7.4053 2.94922 8.67635 3.64396 9.47372 4.71764C9.87933 4.16965 10.4076 3.72427 11.0163 3.41717C11.625 3.11008 12.2972 2.94982 12.979 2.94922C15.4027 2.94922 17.3685 4.9229 17.3685 7.36238C17.3685 12.8887 12.2527 16.1492 9.96319 16.9308Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_6146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9474,
    height: 18.9474,
    fill: "white",
    transform: "translate(0 0.501953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c96f90b0c22135504875842248ff9cb8.svg";
export { ForwardRef as ReactComponent };